// component-popup-modal.js
// Powers blocks rendered with `display_as_popup: true` in product-block.liquid
// Uses the native <dialog> element — no external library needed.

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-js-popup-trigger]');
  if (trigger) {
    const modalId = trigger.getAttribute('aria-controls');
    const modal = document.getElementById(modalId);
    if (modal && typeof modal.showModal === 'function') {
      modal.showModal();
    }
    return;
  }

  const closeBtn = e.target.closest('[data-js-popup-close]');
  if (closeBtn) {
    const modal = closeBtn.closest('[data-js-popup-modal]');
    if (modal) {
      modal.close();
    }
    return;
  }
});

// Close when clicking on the backdrop (i.e. outside .popup-modal__inner)
document.addEventListener('click', (e) => {
  const modal = e.target.closest('[data-js-popup-modal]');
  if (modal && e.target === modal) {
    modal.close();
  }
});

// Prevent background page scroll while a popup modal is open
document.querySelectorAll('[data-js-popup-modal]').forEach((modal) => {
  modal.addEventListener('close', () => {
    document.body.style.removeProperty('overflow');
  });
});

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-js-popup-trigger]');
  if (trigger) {
    document.body.style.overflow = 'hidden';
  }
});